import React, { useState } from "react";

/** Copy to the clipboard, and say so for a moment. */
export default function CopyButton({ text, label = "Copy", className = "crm-bkcopy" }) {
  const [done, setDone] = useState(false);
  return (
    <button
      type="button"
      className={className}
      disabled={!text}
      onClick={async (event) => {
        event.stopPropagation();
        try {
          await navigator.clipboard.writeText(text);
          setDone(true);
          setTimeout(() => setDone(false), 1500);
        } catch {
          /* clipboard blocked: the link is on screen to copy by hand */
        }
      }}
    >
      <span aria-hidden="true">⧉</span> {done ? "Copied" : label}
    </button>
  );
}
